import React from 'react'
import MyPayoutsPanel from '@/modules/affiliates/components/MyPayoutsPanel'

export default function MyRecebimentosPage() {
  return (
    <div className="w-full">
      <h1 className="mb-4 text-2xl font-semibold">Recebíveis</h1>
      <MyPayoutsPanel />
    </div>
  )
}
